// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3cdc2828","977":"517da3b8"}[chunkId] + ".chunk.js";
};